import React, { forwardRef, useImperativeHandle, useEffect, useState } from "react";
import { Endpoints } from "../constants/env/middletier";
import { Dropdown } from 'primereact/dropdown';


const DepartmentsDropdown = forwardRef(function GroupsDropdown(
  { onGetGroup },
  ref
) {
// function GroupsDropdown({ onGetGroup }) {
  const [departments, setDepartments] = useState([]);
  const [departmentsList, setDepartmentsList] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch all departments on mount
  useEffect(() => {
    async function fetchDepartments() {
      try {
        const res = await fetch(Endpoints["getdepartmentsfordropdown"]);
        const data = await res.json();
        setDepartments(data);
        console.log("Data departments");
        console.log(data);
      } catch (err) {
        console.error("Failed to load departments", err);
      } finally {
        setLoading(false);
      }
    }
    fetchDepartments();
  }, []);

    const handleDepartmentChange = (e) => {
//        const departmentName = e.target.value;
//        const department = groups.find((g) => g.name === departmentName);
        setSelectedDepartment(e.value);
//    onGetGroup(e.value);
//    setSelectedGroupSubs(group.substitutes);
    };



  if (loading) return <div>Loading data...</div>;

  return (
    <>
        <div className="card flex justify-content-center">
            <Dropdown
                value={selectedDepartment}
                onChange={handleDepartmentChange}
                options={departments}
                optionLabel="name"
                placeholder="Select a Department" />
        </div>
    </>
  );
});

export default DepartmentsDropdown;
